// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/ParisineOfficeWeb-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/ParisineOfficeWeb-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  overflow: hidden;
  padding-top: 2vmin;
  min-height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 1vmin);
  color: white;
}

body {
  background-color: #25303B;
  overflow: hidden;
  font-family: "Raleway", sans-serif;

}

#intro-screen {
  display: block;
}

.startButton {
  margin-top: 20px;
  padding: 10px 30px;
  border-radius: 35px;
  border: 0;
  font-size: 2vh;
  background-color: #64b5e5;
  color: white;
  font-family: 'Parisine';
  cursor: pointer;

}

.restartzone {
  width: 100%;
}

#restart {
  margin: 20px 0;
  padding: 10px 30px;
  border-radius: 35px;
  border: 0;
  font-size: 2vh;
  background-color: #64b5e5;
  color: white;
  font-family: 'Parisine';
  cursor: pointer;
  display: none;
}


.credits {
  margin: 10px 0 0 0;
  font-size: 1.2vh;
  font-weight: 200;
  font-size: 1vh;
}

@media (max-width: 768px) {
  .startButtonZone {
    position: absolute;
    bottom: 5px;
    left: 10px;
    right: 10px;
  }
  .startButton {
    width: 100%;
  
  }
  .credits {
    margin: 5px 0 0 0;
    font-size: 1.2vh;
  }
}



.description {
  margin: 0 18%;
}

@media (max-width: 768px) {
  .description {
    margin: 0 3px;
  }
}

#game-screen {
  display: none;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@font-face {
  font-family: Parisine;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  text-rendering: optimizeLegibility;
}

h1 {
  font-size: calc(10px + 5vmin);
  margin:0;
}
h1:before {
  color: #64b5e5;
  content: "navigo";
 }
h1:after {
  color: #ffffff;
  content: "dle";
}

h3 {
  margin: 0;
  margin-top: 10px;
}

h5 {
  margin-top: 10px;
  margin-bottom: 10px;
}


.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#searchzone {
  
  margin-top: 90px;
}

input[type="checkbox"] {
  margin-left: 10px;
}

input[type="text"] {
  outline: none;
  width: 50%;
  font-size: 3vh;
  margin-bottom: 0;
  box-sizing: border-box;
  border-color: black;
  border-bottom: 0;
  border-radius: 35px;
  text-align: center;
  font-family: 'Parisine';
}

@media (max-width: 768px) {
  input[type="text"] {
    width: 100%;
    border-radius: 15px 15px 0 0;
  }
  #searchzone {
    
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

#suggestions {
  display: block;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0;
}

.suggestion {
  display: inline-block;
  margin: 10px;
  padding: 10px;
  border-radius: 35px;
  background-color: #64b5e5;
  color: white;
  font-family: 'Parisine';
  cursor: pointer;
}

a {
  text-decoration: none;
  color: rgb(207, 207, 207);
  font-weight: 600;

}

.foundHints {
  display: flex;
  justify-content: center;
}

.disclaimer {
  margin-top: 30px;
  font-size: 1.2vh;
  font-weight: 200;

}

table {
  width: 55%;
  border-collapse: collapse;
  margin-top: 20px;
}

@media (max-width: 768px) {
  table {
    width: 90%;
  }

}

@media (max-width: 480px) {
  table {
    width: 99%;
  }
}

table, th, td {
  border: 1px solid black;
}

th {
  padding: 10px;
  background-color: #25303B;
  color: white;
  font-family: 'Parisine';
}

td {
  padding: 10px;
  background-color: #25303B;
  color: bwhitelack;
  font-family: 'Parisine';
  height: 100%;
}

tr {
  min-height: 50px;
}

.guesslist {
  max-height: 40vh;
  overflow-y: scroll;
}

.not-found {
  background-color: #25303B;
  color: white;
}

.nom {
  
  font-family: 'Parisine';
}

.wrong {
  background-color: #d85454;
  color: black;
}

.correct {
  background-color: #53B476;
  color: black;
}

.life {
  width: 3ch;
}

.partial {
  background-color: #ffe500;
  color: black;
}

.pictoligne {
  width: 3ch;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;;AAEpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;;AAEjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;;EAEb;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,qBAAqB;EACrB;wDAC4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;;IAEE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;EACV;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\n\n\n\n.App {\n  text-align: center;\n  overflow: hidden;\n  padding-top: 2vmin;\n  min-height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 1vmin);\n  color: white;\n}\n\nbody {\n  background-color: #25303B;\n  overflow: hidden;\n  font-family: \"Raleway\", sans-serif;\n\n}\n\n#intro-screen {\n  display: block;\n}\n\n.startButton {\n  margin-top: 20px;\n  padding: 10px 30px;\n  border-radius: 35px;\n  border: 0;\n  font-size: 2vh;\n  background-color: #64b5e5;\n  color: white;\n  font-family: 'Parisine';\n  cursor: pointer;\n\n}\n\n.restartzone {\n  width: 100%;\n}\n\n#restart {\n  margin: 20px 0;\n  padding: 10px 30px;\n  border-radius: 35px;\n  border: 0;\n  font-size: 2vh;\n  background-color: #64b5e5;\n  color: white;\n  font-family: 'Parisine';\n  cursor: pointer;\n  display: none;\n}\n\n\n.credits {\n  margin: 10px 0 0 0;\n  font-size: 1.2vh;\n  font-weight: 200;\n  font-size: 1vh;\n}\n\n@media (max-width: 768px) {\n  .startButtonZone {\n    position: absolute;\n    bottom: 5px;\n    left: 10px;\n    right: 10px;\n  }\n  .startButton {\n    width: 100%;\n  \n  }\n  .credits {\n    margin: 5px 0 0 0;\n    font-size: 1.2vh;\n  }\n}\n\n\n\n.description {\n  margin: 0 18%;\n}\n\n@media (max-width: 768px) {\n  .description {\n    margin: 0 3px;\n  }\n}\n\n#game-screen {\n  display: none;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@font-face {\n  font-family: Parisine;\n  src: url('./fonts/ParisineOfficeWeb-Regular.woff2') format('woff2'),\n  url('./fonts/ParisineOfficeWeb-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n  text-rendering: optimizeLegibility;\n}\n\nh1 {\n  font-size: calc(10px + 5vmin);\n  margin:0;\n}\nh1:before {\n  color: #64b5e5;\n  content: \"navigo\";\n }\nh1:after {\n  color: #ffffff;\n  content: \"dle\";\n}\n\nh3 {\n  margin: 0;\n  margin-top: 10px;\n}\n\nh5 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#searchzone {\n  \n  margin-top: 90px;\n}\n\ninput[type=\"checkbox\"] {\n  margin-left: 10px;\n}\n\ninput[type=\"text\"] {\n  outline: none;\n  width: 50%;\n  font-size: 3vh;\n  margin-bottom: 0;\n  box-sizing: border-box;\n  border-color: black;\n  border-bottom: 0;\n  border-radius: 35px;\n  text-align: center;\n  font-family: 'Parisine';\n}\n\n@media (max-width: 768px) {\n  input[type=\"text\"] {\n    width: 100%;\n    border-radius: 15px 15px 0 0;\n  }\n  #searchzone {\n    \n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n}\n\n#suggestions {\n  display: block;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 0;\n}\n\n.suggestion {\n  display: inline-block;\n  margin: 10px;\n  padding: 10px;\n  border-radius: 35px;\n  background-color: #64b5e5;\n  color: white;\n  font-family: 'Parisine';\n  cursor: pointer;\n}\n\na {\n  text-decoration: none;\n  color: rgb(207, 207, 207);\n  font-weight: 600;\n\n}\n\n.foundHints {\n  display: flex;\n  justify-content: center;\n}\n\n.disclaimer {\n  margin-top: 30px;\n  font-size: 1.2vh;\n  font-weight: 200;\n\n}\n\ntable {\n  width: 55%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  table {\n    width: 90%;\n  }\n\n}\n\n@media (max-width: 480px) {\n  table {\n    width: 99%;\n  }\n}\n\ntable, th, td {\n  border: 1px solid black;\n}\n\nth {\n  padding: 10px;\n  background-color: #25303B;\n  color: white;\n  font-family: 'Parisine';\n}\n\ntd {\n  padding: 10px;\n  background-color: #25303B;\n  color: bwhitelack;\n  font-family: 'Parisine';\n  height: 100%;\n}\n\ntr {\n  min-height: 50px;\n}\n\n.guesslist {\n  max-height: 40vh;\n  overflow-y: scroll;\n}\n\n.not-found {\n  background-color: #25303B;\n  color: white;\n}\n\n.nom {\n  \n  font-family: 'Parisine';\n}\n\n.wrong {\n  background-color: #d85454;\n  color: black;\n}\n\n.correct {\n  background-color: #53B476;\n  color: black;\n}\n\n.life {\n  width: 3ch;\n}\n\n.partial {\n  background-color: #ffe500;\n  color: black;\n}\n\n.pictoligne {\n  width: 3ch;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
